import gsap from 'gsap'

const setupTopNavigation = (el) => {
  let lastKnownScrollPos = 0
  let currentPos = window.scrollY
  let ticking = false
  let hidden = false

  function hideNavigation() {
    hidden = true

    gsap.to(el, {
      y: '-100%',
      duration: 0.4,
    })
  }

  function showNavigation() {
    hidden = false

    gsap.to(el, {
      y: '0%',
      duration: 0.4,
    })
  }

  function updateScrollState() {
    ticking = false

    if (currentPos > lastKnownScrollPos && !hidden) {
      hideNavigation()
    }

    if (currentPos < lastKnownScrollPos && hidden) {
      showNavigation()
    }

    if (currentPos > 200) {
      gsap.set(el, {
        backgroundColor: '#00453A',
      })
    } else {
      gsap.set(el, {
        backgroundColor: 'transparent',
      })
    }

    lastKnownScrollPos = currentPos
  }

  function requestTick() {
    if (!ticking) {
      window.requestAnimationFrame(updateScrollState)
      ticking = true
    }
  }

  function onScroll() {
    window.requestAnimationFrame(() => {
      currentPos = window.scrollY
      requestTick()
    })
  }

  window.addEventListener('scroll', onScroll, {
    passive: true,
  })
}

export default setupTopNavigation
